import * as yup from "yup";

export type SplitListingAdvancedType = yup.InferType<typeof SplitListingAdvanced>;

export const SplitListingAdvanced = yup.object().shape({
	Number_Of_Groups: yup.number().min(2, "").typeError("").required().max(yup.ref("$maxQuantity"), ""),
});
